module.exports = __webpack_public_path__ + "assets/img/cv-active-bg-dafcf376.png";